import React from "react";

const CtaNavBack = ({ handleClick = false }) => {
  return (
    <span
      className="nav-back"
      onClick={handleClick ? () => handleClick() : null}
    />
  );
};

export default CtaNavBack;
